export default "__VITE_ASSET__Dua7Q3Zm__"